import { GoogleTagManager as commonTagManager } from "@obs/components";

import { getEnv, getEnvVariables } from "../utils/env.utils";

export const GoogleTagManager = () => {
	return commonTagManager({
		isEnabled: getEnv() !== "PROD",
		tagId: getEnvVariables().GOOGLE_TAG_MANAGER_TAG_ID,
		url: "https://www.googletagmanager.com/gtag/js?id=G-63BJLRP7J1",
	});
};
